<!-- todo: add buttons to set interval time up and down -->
<template>
  <div v-cloak>
    

    <p class="h3" style="margin-top:0vw;margin-bottom:0vw;padding-top:3vw;">Interval Time Period</p>
    
    <div class="flex justify-content-center">
      <p @contextmenu="discard" class="h2" style="font-size:3.5vw;padding-bottom:0.5vw;margin-top:0vw;">{{ timeDisplay(intervalTime) }}</p>
      <svg style="width:6vw;height:6vw;margin-left:2vw;margin-top:-1vw;vertical-align:middle" viewBox="0 0 512 512" fill="none" stroke="currentColor" stroke-width="48" stroke-linecap="round" stroke-linejoin="round" @click="down"><polyline points="112,176 256,336 400,176"/></svg>
      <svg style="width:6vw;height:6vw;margin-top:-1vw;vertical-align:middle" viewBox="0 0 512 512" fill="none" stroke="currentColor" stroke-width="48" stroke-linecap="round" stroke-linejoin="round" @click="up"><polyline points="112,336 256,176 400,336"/></svg>
    </div>
      
  </div>
</template>


<script>
  export default {
    name: 'intervalTime',
    emits:["up","down"],
    props: {
      intervalTime:Number,
    },
    data() {
      return {
      }
    },
    methods: {
      up() {
        this.$emit("up");
      },
      down() {
        this.$emit("down");
      },
      timeDisplay(timeSeconds) {
        const hours = Math.floor(timeSeconds / 3600);
        const secondsRemaining = timeSeconds%3600;
        const minutes = Math.floor(secondsRemaining / 60);
        const seconds = secondsRemaining % 60;
        
        const tHours = hours<10?"0"+hours:hours;
        const tMinutes = minutes<10?"0"+minutes:minutes;
        const tSeconds = seconds<10?"0"+seconds:seconds;

        return tHours + ":" + tMinutes + ":" + tSeconds;
      },
    },
    computed: {
    },
    watch: {  
    },
    mounted() {
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .option {
    font-size:7vw;
    line-height:9vw;
  }

  p {
    margin-top:0.5vw;
    margin-bottom:0.5vw;
  }

  .h2 {
    font-weight:500;
  }

  .h3 {
    font-size:2vw;
  }

</style>
